import { render, staticRenderFns } from "./createCertification.vue?vue&type=template&id=15db2c96&scoped=true&"
import script from "./createCertification.vue?vue&type=script&lang=js&"
export * from "./createCertification.vue?vue&type=script&lang=js&"
import style0 from "./createCertification.vue?vue&type=style&index=0&id=15db2c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db2c96",
  null
  
)

export default component.exports